import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClassroomStoreModule } from '@modules/course/classroom/store/classroom-store.module';
import { IdentityStoreModule } from '@modules/identity/store/identity-store.module';
import { SharedModule } from '@shared/shared.module';
import { CountryStoreModule } from '@shared/store/country-store/country-store.module';
import { CultureStoreModule } from '@shared/store/culture-store/culture-store.module';
import { AccountClientModule } from '../account/client/account.client.module';
import { PaymentClientModule } from '../payment/client/payment.client.module';
import { InstructorClientModule } from './client/instructor.client.module';
import { BankAccountFormComponent } from './components/bank-account-form/bank-account-form.component';
import { BasicInfoFormComponent } from './components/basic-info-form/basic-info-form.component';
// tslint:disable-next-line: max-line-length
import { IdentityVerificationFormComponent } from './components/identity-verification-form/identity-verification-form.component';
import { ExperienceComponent } from './components/my-courses/my-courses.component';
import { GuideRouteModule } from './instructor.router.module';
import { InstructorCalendarComponent } from './pages/instructor-calendar/instructor-calendar.component';
import { InstructorDetailsComponent } from './pages/instructor-details/instructor-details.component';
import { InstructorRequestCompleteComponent } from './pages/instructor-request-complete/instructor-request-complete.component';
import { InstructorRequestComponent } from './pages/instructor-request/instructor-request.component';
import { InstructorWrapperComponent } from './pages/instructor-wrapper/instructor-wrapper.component';
import { MyFeedbacksComponent } from "@modules/instructor/components/my-feedbacks/my-feedbacks.component";
import { MatTableModule } from "@angular/material/table";
import {
  InstructorListComponent
} from "@modules/instructor/pages/instructor-list/instructor-list.component";
import {
  InstructorsCardComponent
} from "@modules/instructor/components/instructors-card/instructors-card.component";
import {
  InstructorsFilterComponent
} from "@modules/instructor/components/instructors-filter/instructors-filter.component";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CategoryClientModule } from '@modules/category/client/category.client.module';
import { CategoriesResolver } from '@modules/category/resolvers/categories.resolver';
import { CategoryStoreService } from '@modules/category/client/store/category.store.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';



@NgModule({
  declarations: [
    InstructorWrapperComponent,
    InstructorListComponent,
    InstructorsFilterComponent,
    InstructorsCardComponent,
    InstructorDetailsComponent,
    InstructorRequestComponent,
    BasicInfoFormComponent,
    IdentityVerificationFormComponent,
    BankAccountFormComponent,
    ExperienceComponent,
    MyFeedbacksComponent,
    InstructorCalendarComponent,
    InstructorRequestCompleteComponent,
  ],
  exports: [],
  imports: [
    GuideRouteModule,
    SharedModule,
    CommonModule,
    PaymentClientModule,
    InstructorClientModule,
    CountryStoreModule,
    CultureStoreModule,
    AccountClientModule,
    IdentityStoreModule,
    ClassroomStoreModule,
    CategoryClientModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    InfiniteScrollModule
  ],
  providers: [CategoriesResolver, CategoryStoreService],
})
export class InstructorModule {}
